import { MenuTypes } from '@ori-events/toggle-menu-flyout';
import { useEffect } from 'react';

import { useActiveMenu } from '../context/navigation/activeMenuContext';
import { dispatchToggleMenu } from '../utils';

export const useClickSignInButtonSupportCenter = () => {
  const { activeMenu } = useActiveMenu();
  useEffect(() => {
    const loginButton = document.querySelector('.support-center-footer-login__button');
    const onClick = (event: Event) => {
      event.preventDefault();
      dispatchToggleMenu(MenuTypes.AccountSideMenu, activeMenu);
    };
    loginButton?.addEventListener('click', onClick);

    return () => loginButton?.removeEventListener('click', onClick);
  }, [activeMenu]);
};
